'use client';

import { useUserContext } from '@/context/user';
import { useQuery } from '@apollo/client';
import clsx from 'clsx';
import { GET_CUSTOMER_INFORMATION } from '../AccountInformationPage/accountInformationPage.gql';
// import FacebookGroupBadge from './facebookGroupBadge'
// import FacebookGroupContribution from './facebookGroupContribution'
import FollowUs from './followUs';
import Interaction from './interaction';

const EarnPoints = props => {
  const [{ isSignedIn }] = useUserContext();
  const { data: accountInformationData } = useQuery(GET_CUSTOMER_INFORMATION, {
    skip: !isSignedIn,
    fetchPolicy: 'cache-and-network',
  });

  const operationAvailableMap =
    accountInformationData?.customer.redeemPoints.reduce((prev, cur) => {
      prev[cur.code] = cur.state === 0;

      return prev;
    }, {}) || {};
  const birthDay = accountInformationData?.customer.date_of_birth;
  const shareCode = accountInformationData?.customer.share_code;

  return (
    <div className={clsx('font-poppins', props.className)}>
      <h2
        className=' text-center font-poppins text-lg font-[600] leading-[22px] text-primary lg_text-[30px] lg_leading-10'
        id='earn-points'
      >
        EARN POINTS
      </h2>
      <Interaction
        operationAvailableMap={operationAvailableMap}
        birthDay={birthDay}
        shareCode={shareCode}
        className='mt-5 lg_mt-[30px]'
      />
      <FollowUs
        operationAvailableMap={operationAvailableMap}
        className='mt-[15px] lg_mt-[50px]'
      />
      {/* <FacebookGroupBadge
                operationAvailableMap={operationAvailableMap}
                className="mt-[15px] lg_mt-[50px]"
            />
            <FacebookGroupContribution
                operationAvailableMap={operationAvailableMap}
                className="mt-[15px] lg_mt-[50px]"
            /> */}
    </div>
  );
};

export default EarnPoints;
